import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarV2FilterButtonAppliedIcon from './VeltCommentsSidebarV2FilterButtonAppliedIcon/VeltCommentsSidebarV2FilterButtonAppliedIcon';
var VeltCommentsSidebarV2FilterButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-button-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterButton.AppliedIcon = VeltCommentsSidebarV2FilterButtonAppliedIcon;
export default VeltCommentsSidebarV2FilterButton;
